import { Link } from "react-router-dom";
import { Search, Heart, Bell, Gift, Shield, DollarSign, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FEATURES = [
  { icon: Search, t: "Personalized Discovery", d: "Tell us what you like and we'll surface creators worth your time." },
  { icon: Heart, t: "Follow & Save", d: "Build your list of favorites and never miss a drop." },
  { icon: Bell, t: "Never Miss An Update", d: "Get notified the moment your favorite creators post something new." },
  { icon: Gift, t: "Support How You Want", d: "Tip, subscribe, or unlock exclusive content — your choice." },
  { icon: Shield, t: "Safe & Private", d: "Your identity and payment info stay protected — always." },
  { icon: DollarSign, t: "Free Forever", d: "No monthly fee to be a fan. Only pay when you choose to." },
];

export default function ForFans() {
  return (
    <div className="pt-32 pb-20">
      <section className="max-w-4xl mx-auto px-6 text-center">
        <Reveal>
          <p className="overline text-violet-300 mb-4">For Fans</p>
          <h1 className="font-display text-5xl md:text-6xl text-white leading-tight">Find Creators<br /><span className="text-brand">You'll Love.</span></h1>
          <p className="mt-5 text-white/65 text-lg max-w-2xl mx-auto">Free to join. Free to browse. Free forever. Only pay when you decide to support a creator you love.</p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/signup?type=fan" className="bg-violet-500 text-white px-8 py-3.5 rounded-lg font-semibold inline-flex items-center gap-2" data-testid="ff-join">Join Free <ArrowRight size={15} /></Link>
            <Link to="/discover" className="border border-white/25 text-white px-8 py-3.5 rounded-lg font-semibold hover:border-violet-400 hover:text-violet-300 transition-colors" data-testid="ff-browse">Browse Creators</Link>
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 mt-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {FEATURES.map((f, i) => (
          <Reveal key={i} delay={(i%3)*0.06}>
            <div className="card p-7 h-full" data-testid={`ff-feat-${i}`}>
              <f.icon className="text-violet-300" size={28} strokeWidth={1.5} />
              <h3 className="text-white font-semibold text-lg mt-4">{f.t}</h3>
              <p className="text-white/60 text-sm mt-2 leading-relaxed">{f.d}</p>
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
